import './AccessCTACard.scss';
import AccessAppImg from '../../../static/images/access-app.png';
import React from 'react';
import { KiteLink } from '@kite/react-kite';

const AccessCTACard = () => {
  return (
    <div className="access-cta-card">
      <img className="access-cta-card__access-app-img" src={AccessAppImg} />
      <div className="access-cta-card__text-content">
        <KiteLink
          href="/access"
          type="standalone-icon"
          target="_blank"
          className="access-cta-card__cta-link"
        >
          Download Spectrum Access
        </KiteLink>
        <p className="access-cta-card__cta-text">
          Get audio descriptions & closed captions
        </p>
      </div>
    </div>
  );
};

export default AccessCTACard;
